import {
    SET_REF_LEAD_CUSTOMER_REDUCER,
    CHANGE_LEADS_CUSTOMER_REQUEST,
    CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS,
    CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE,
    UPDATE_LEAD_CUSTOMER_DATE_REQUEST,
} from '../constants/get_lead_profile.constants';

import {
    ADD_DATA_BY_STREET_REQUEST_FAILURE,
    ADD_DATA_BY_STREET_REQUEST_SUCCESS,
    ADDRESS_LOOKUP_REQUEST_FAILURE,
    ADDRESS_LOOKUP_REQUEST_SUCCESS,
} from '../constants/address_lookup.constants';
import {
    SEARCH_LEAD_COUNTY_REQUEST_FAILURE,
    SEARCH_LEAD_COUNTY_REQUEST_SUCCESS,
} from '../constants/search_lead_county.constants';

const initialState = {
    loading: false,
    customer_details: null,
    isEditField: false,
    index: null,
    streets: null,
    counties: [],
    data_by_streets: null,
    error: null,
};

export const Ref_lead_customer = (state = initialState, action) => {
    switch (action.type) {
    case SET_REF_LEAD_CUSTOMER_REDUCER:
        return {
            ...state,
            customer_details: action.payload,
        };
    case 'EDIT_FIELD':
        return {
            ...state,
            isEditField: action.status,
            index: action.index,
        };
    case 'LEAD_HANDLER':
        return {
            ...state,
            customer_details: /full_name|email|phone|preferred_contact_time|preferred_contact_method|customer_collection_date/.test(action.key) ? {
                ...state.customer_details,
                [action.key]: action.value,
            } : {
                ...state.customer_details,
                address: (action.obj === 'county') ? {
                    ...state.customer_details.address,
                    [action.obj]: {
                        ...state.customer_details.address[action.obj],
                        name: action.value.props.children,
                        _id: action.key,
                    },
                } : {
                    ...state.customer_details.address,
                    [action.key]: action.value,
                },
            },
        };
    case UPDATE_LEAD_CUSTOMER_DATE_REQUEST:
    case CHANGE_LEADS_CUSTOMER_REQUEST:
        return {
            ...state,
            loading: true,
        };
    case CHANGE_LEADS_CUSTOMER_REQUEST_SUCCESS:
        return {
            ...state,
            loading: false,
            customer_details: { ...state.customer_details, ...action.payload },
            isEditField: false,
        };
    case ADDRESS_LOOKUP_REQUEST_SUCCESS:
        return {
            ...state,
            streets: action.payload,
        };
    case ADD_DATA_BY_STREET_REQUEST_SUCCESS:
        return {
            ...state,
            data_by_streets: action.payload,
        };
    case SEARCH_LEAD_COUNTY_REQUEST_SUCCESS:
        return {
            ...state,
            counties: action.payload,
        };
    case CHANGE_LEADS_CUSTOMER_REQUEST_FAILURE:
    case ADD_DATA_BY_STREET_REQUEST_FAILURE:
    case ADDRESS_LOOKUP_REQUEST_FAILURE:
    case SEARCH_LEAD_COUNTY_REQUEST_FAILURE:
        return {
            ...state,
            loading: false,
            error: action.error,
        };
    default:
        return state;
    }
};



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/reducers/ref_lead_customer.reducer.js